
import React, { Component } from 'react';
import $ from 'jquery';
import careerImg from "../images/career.png"
import ivanoImg1 from "../images/ivano-1.png"
import ivanoImg2 from "../images/ivano-2.png"
import ivanoImg3 from "../images/ivano-3.png"
import ivanoImg4 from "../images/ivano-4.png"

export default class IvanoWorks extends Component {
    render() {

    return (

      <section className="iavno-works-wrapper">
        <div className="container">
              <div className="iavno-works-panel"> 
          <div className="row">
            <div className="iavno-works-head text-center">
              <h4>How ivanooo works</h4>
              {/* <p>Your personalized career assistance to assist you in identifying your career goals and help achieve them:</p> */}
            </div>
            <div className="col-md-12">
                <div className="iavno-works-body">
                  <div className="iavno-works-box">
                    <a href="#" className="iavno-works-box-a">
                      <img alt="" className="iavno-works-img" src={careerImg} />
                      <p className="iavno-works-box-subtext">Get started with the discovery session. There we will assess your skills and identify your career goals.</p>
                    </a>
                  </div>
                  <div className="iavno-works-box">
                    <a href="#" className="iavno-works-box-a">
                      <img alt="" className="iavno-works-img" src={careerImg} />
                      <p className="iavno-works-box-subtext">Based on your goals and skillsets, we will run a skill-gap analysis which will help in refining our recommendations.</p>
                    </a>
                  </div>
                  <div className="iavno-works-box">
                    <a href="#" className="iavno-works-box-a">
                      <img alt="" className="iavno-works-img" src={careerImg} />
                      <p className="iavno-works-box-subtext">Get access to a dashboard where you can track our recommendations.</p>
                    </a>
                  </div>
                </div>
              </div>


          </div>
        </div>
      </div>
    </section>
      )
    }
}


// WEBPACK FOOTER //
// ./src/home/ivanoWorks.jsx